export const createFileSlice = (set, get) => ({
    getImg: {
        loading: false,
        data: [],
    },
    FILE_LOADING: (payload) => set(state => ({
        getImg: {
            ...state.getImg,
            loading: payload
        }
    })),
    GET_BUSINESS_LOGO_SUCCESS: (payload) => set(state => ({
        getImg: {
            ...state.getImg,
            data: payload
        }
    })),
});
